import { useState, useEffect, useRef } from 'react';
import apiClient from '../../utils/api';

const AlgoDepositPanel = ({ addToast }) => {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copying, setCopying] = useState(false);
  const addressRef = useRef(null);

  const refreshWallet = async () => {
    setLoading(true);
    try {
      const res = await apiClient.getMyAlgorandWallet();
      setWallet(res.data || null);
    } catch (_) {
      setWallet(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshWallet();
  }, []);

  const copyAddress = async () => {
    if (!wallet?.address) return;
    setCopying(true);
    try {
      await navigator.clipboard.writeText(wallet.address);
      addToast?.("Address copied.", "success");
    } catch (_) {
      addressRef.current?.focus();
      addressRef.current?.select();
      addToast?.("Select the address and copy manually.", "info");
    } finally {
      setCopying(false);
    }
  };

  if (loading) {
    return <p style={{ color: "var(--text-light)", fontSize: "0.9rem" }}><i className="fas fa-spinner fa-spin" aria-hidden="true"></i> Loading Algorand wallet…</p>;
  }

  if (!wallet?.enabled) {
    return (
      <div className="deposit-form__unconfigured">
        <p><strong>Algorand deposits are not enabled.</strong></p>
      </div>
    );
  }

  if (!wallet.address) {
    return (
      <div className="deposit-form__unconfigured">
        <p><strong>Algorand wallet not ready yet.</strong></p>
      </div>
    );
  }

  return (
    <div className="algo-deposit-panel">
      <p className="deposit-form__lead">
        Send <strong>ALGO</strong> (or USDC) from Pera, an exchange, or any Algorand wallet to your CoOwn embedded address below.
        At invest checkout, choose <strong>Algorand → ALGO</strong> — the platform converts ALGO to USDC automatically before shares are issued.
      </p>
      <div className="algo-deposit-panel__balances">
        <div>
          <span className="algo-deposit-panel__balance-label">ALGO balance</span>
          <strong>{Number(wallet.algoBalance || 0).toLocaleString(undefined, { maximumFractionDigits: 6 })} ALGO</strong>
        </div>
        {wallet.cryptoCheckoutReady ? (
          <div>
            <span className="algo-deposit-panel__balance-label">USDC balance</span>
            <strong>{Number(wallet.usdcBalance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDC</strong>
          </div>
        ) : null}
      </div>
      <label className="algo-deposit-panel__field-label" htmlFor="algo-deposit-address">Your deposit address</label>
      <div className="algo-deposit-panel__address-row">
        <input
          ref={addressRef}
          id="algo-deposit-address"
          readOnly
          value={wallet.address}
          onFocus={(e) => e.target.select()}
          onClick={(e) => e.target.select()}
          className="profile-wallet-card__address"
          aria-label="Algorand deposit address"
        />
        <button type="button" className="btn btn-outline btn-sm profile-wallet-card__copy" onClick={copyAddress} disabled={copying}>
          <i className={`fas fa-${copying ? "spinner fa-spin" : "copy"}`} aria-hidden="true"></i>
          <span style={{ marginLeft: "0.35rem" }}>Copy</span>
        </button>
      </div>
      <p className="algo-deposit-panel__network">Network: {wallet.network || "testnet"}</p>
      <button type="button" className="btn btn-outline btn-sm" onClick={refreshWallet} style={{ marginTop: "0.75rem" }}>
        <i className="fas fa-sync" aria-hidden="true"></i> Refresh balance
      </button>
    </div>
  );
};

export default AlgoDepositPanel;
